// extracted by mini-css-extract-plugin
export default {"wrapper":"uR-z","availablePromoMessagesLabel":"vR-z","promoMessageList":"wR-z","promoMessage":"xR-z","appliedPromoMessage":"yR-z","promoMessageAmount":"zR-z"};